var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonLink, TrailingIcon, Trans } from '@lucidlink/uicore';
import { DESKTOP_APPLICATION_DOWNLOAD_URL } from '@lucidlink/workspacemanagement';
export const DownloadDesktopAppLink = () => (_jsx(ButtonLink, { "data-testid": "download-app", kind: "ghost", StartIcon: TrailingIcon, target: "_blank", to: DESKTOP_APPLICATION_DOWNLOAD_URL, children: _jsx(Trans, { children: "Download application" }) }));
_react_refresh_temp_1 = DownloadDesktopAppLink;
$RefreshReg$(_react_refresh_temp_1, "DownloadDesktopAppLink");
